import { Flex } from "antd";
import { ComponentPropsWithoutRef } from "react";

interface StructuredLayoutComponentProps extends Partial<
  ComponentPropsWithoutRef<typeof Flex>
> {
  header?: React.ReactNode;
  navigation?: React.ReactNode;
  contentStyle?: React.CSSProperties;
}
const StructuredLayoutComponent: React.FC<StructuredLayoutComponentProps> = ({
  header,
  children,
  navigation,
  contentStyle,
}) => {
  return (
    <Flex vertical>
      {header && <div style={{ margin: 0, marginBottom: 60 }}>{header}</div>}
      <Flex
        justify="center"
        align="center"
        gap={64}
        style={{ paddingBottom: 100, ...contentStyle }}
      >
        {children}
      </Flex>
      {navigation}
    </Flex>
  );
};

export default StructuredLayoutComponent;
